module.exports = __webpack_public_path__ + "img/nature-79.df1c40e2.jpg";